<template>
	<div class="h-[calc(100vh)] w-screen">
		<AppHeader :show-collapse-toggle="false" />
		<slot />
	</div>
</template>

<script setup>
import AppHeader from '../components/app-header.vue';
</script>
